<div id="class_schedule">
  <ng-container>
    <app-legends
      [OnwaitingList]="onWaitingList"
      [fullyBooked]="onFullyBooked"
    ></app-legends>
    <span
      *ngIf="isWaitingTrue === true"
      class="select-waiting-class-schedule"
      >{{ waitingListMessage }}</span
    >
    <app-class-schedule-grid-view
      [selectedProgramId]="selectedProgramId"
      [kidName]="kidName"
      [isWaitingTrue]="isWaitingTrue"
      [selectedKid]="selectedKid"
      [rows]="classScheduleList"
      [selected]="selected"
      (setClassScheduleListForProgramRegistration)="
        setClassScheduleListForProgramRegistration.emit($event)
      "
      [feeByProgram]="feeByProgram"
    ></app-class-schedule-grid-view>
    <app-class-schedule-compact-view
      [selectedProgramId]="selectedProgramId"
      [kidName]="kidName"
      [isWaitingTrue]="isWaitingTrue"
      [selectedKid]="selectedKid"
      [selected]="selected"
      (setClassScheduleListForProgramRegistration)="
        setClassScheduleListForProgramRegistration.emit($event)
      "
      [feeByProgram]="feeByProgram"
      [rows]="classScheduleList"
    ></app-class-schedule-compact-view>
  </ng-container>
</div>
